import type {
	CanonicalId,
	JiraProjectType,
} from '@atlassian/jira-common-constants/src/project-types';
import addPaymentMethodButtonTrialModalQueryParameters from '@atlassian/jira-relay/src/__generated__/addPaymentMethodButtonTrialModalQuery$parameters';
import mainProjectKeysTrialAwarenessModalQueryParameters from '@atlassian/jira-relay/src/__generated__/main_EditionAwarenessTrialModalQuery$parameters';
import timelineSectionTrialStartDateTrialModalQueryParameters from '@atlassian/jira-relay/src/__generated__/timelineSectionTrialStartDateTrialAwarenessModalQuery$parameters';
import userLimitSlideProjectKeysTrialAwarenessModalQueryParameters from '@atlassian/jira-relay/src/__generated__/userLimitSlideProjectKeysTrialAwarenessModalQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	cloudId: string;
	productKey: CanonicalId;
	jiraProjectType: JiraProjectType;
};

export const editionAwarenessTrialModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "edition-awareness-trial-modal" */ './src/ui'),
	),
	getPreloadProps: ({ cloudId, productKey, jiraProjectType }: EntryPointParams) => ({
		extraProps: { productKey },
		entryPoints: {},
		queries: {
			billingUrlQueryRef: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters: addPaymentMethodButtonTrialModalQueryParameters,
				variables: {
					cloudIds: [cloudId],
					hamsProductKey: productKey,
				},
			},
			trialStartQueryRef: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters: timelineSectionTrialStartDateTrialModalQueryParameters,
				variables: {
					cloudIds: [cloudId],
					hamsProductKey: productKey,
				},
			},
			projectKeysQueryRef: {
				parameters: userLimitSlideProjectKeysTrialAwarenessModalQueryParameters,
				variables: {
					cloudId,
					projectTypes: [jiraProjectType],
				},
			},
			editionAwarenessTrialModalQueryRef: {
				parameters: mainProjectKeysTrialAwarenessModalQueryParameters,
				variables: {
					cloudIds: [cloudId],
					hamsProductKey: productKey,
				},
			},
		},
	}),
});
